// extracted by mini-css-extract-plugin
module.exports = {"content":"_26PPM","heading":"_1rsAp","documentCol":"_1_F0P","wrap":"unQzQ"};